import elementExists from "../../../core/utils/element-exists";
const ProductClosureFilters = function(){
    let filters =  [];
    /**
     * Init closure filters
     */
    const init = function(){
        const filterContainer = document.querySelector('[closure-filters]');
        if( elementExists( filterContainer )){
            const filters = filterContainer.querySelectorAll('[closure-filter]');
            if( elementExists( filters, true )){
                filters.forEach( filter => {
                    filter.addEventListener('click', function( $event ){
                        $event.preventDefault();
                        udpateFilters( filter.dataset , $event.currentTarget )
                    });
                });
            }
        }
    }

    /**
     * update the filters array then apply
     * @param {*} filter 
     * @param {*} target 
     */
    const udpateFilters = function( filter , target ){
        const { value , group } = filter;
        const container = target.closest( '.dropdown');
        const label = container.querySelector('.dropdown-toggle span');
        const filterGroup = filters.find( filter => filter.group == group );
        if( filterGroup || ( group == value ) ) {
            filters = filters.filter( filter => filter.group !== group );
        }
        if( group !== value ){
            filters.push({ group : group , value : value });
        }
        label.innerText = value;
        applyFilters();
    }

    /**
     * Apply filters to closure items
     * @return void
     */
    const applyFilters = function(){
        const closureItems = document.querySelectorAll( '[closure-filter-item]');
        if( elementExists( closureItems )){
            if(filters.length == 0 ){
                closureItems.forEach( closureItem => {
                    closureItem.classList.remove('d-none');
                });
            }
            if( filters.length > 0 ) {
                closureItems.forEach( closureItem => {
                    let show = true;
                    filters.forEach( filter => {
                        if( closureItem.dataset[ filter.group.toLowerCase() ] !== filter.value ) show = false;
                    });
                    if( show ){
                        closureItem.classList.remove('d-none');
                    }
                    else{
                        closureItem.classList.add('d-none');
                    }

                });
            }
        }
    }
    init();
}

export default ProductClosureFilters;